/**
 * Shared constants and utilities for the runs-ui application
 */

/**
 * Period options for time range selectors
 */
export const PERIOD_OPTIONS = [
  { value: '7d', label: 'Last 7 days', days: 7 },
  { value: '14d', label: 'Last 14 days', days: 14 },
  { value: '30d', label: 'Last 30 days', days: 30 },
  { value: '90d', label: 'Last 90 days', days: 90 },
] as const

export type PeriodValue = typeof PERIOD_OPTIONS[number]['value']

/**
 * Calculate date range from period value
 * @param period - Period value (7d, 14d, 30d, 90d)
 * @returns Object with ISO date strings for from and to
 */
export function getDateRange(period: PeriodValue): { from: string; to: string } {
  const to = new Date()
  const from = new Date()
  const days = PERIOD_OPTIONS.find(p => p.value === period)?.days ?? 30
  from.setDate(from.getDate() - days)
  
  return {
    from: from.toISOString(),
    to: to.toISOString()
  }
}
